var map = {
	"./en-translateLevelContentData.js": [
		1908,
		908
	],
	"./es-translateLevelContentData.js": [
		9411,
		411
	],
	"./fr-translateLevelContentData.js": [
		6303,
		303
	],
	"./it-translateLevelContentData.js": [
		210,
		210
	],
	"./pt-translateLevelContentData.js": [
		8187,
		187
	],
	"./tr-translateLevelContentData.js": [
		9637,
		637
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 3736;
module.exports = webpackAsyncContext;